import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { KnBrRequestQuoteComponent } from './kn-br-request-quote/kn-br-request-quote.component';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { SalesCheckoutPageLayoutHandler } from './request-quote-page-layout.handler';


@NgModule({
  declarations: [],
  imports: [CommonModule,
     ConfigModule.withConfig({
            cmsComponents: {
                RequestQuotePageFlexComponent: {
                    component: KnBrRequestQuoteComponent,
                }
            },
            KnBrRequestQuoteComponent
        } as CmsConfig),
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: SalesCheckoutPageLayoutHandler,
      multi: true,
    },
  ],
})
export class KnBrRequestQuoteModule {}
